import _ from 'lodash';
import { Part } from 'types/part';
import { DecoratedKitRequestLine } from 'hooks/useGetDecoratedKitRequestLines';

export function findDuplicateV2PartsInRows(
  rowData: DecoratedKitRequestLine[]
): Part['mpn'][] {
  const duplicatePartUUIDs = _.chain(rowData)
    .map((r) => [r.v2OrgPart, ...(r.altV2OrgParts ?? [])])
    .flatten()
    .compact()
    .countBy()
    .pickBy((value) => value > 1)
    .keys()
    .value();

  const allPartsInRows = _.flatMap(rowData, (r) => r.v2OrgParts);

  const duplicateMpns = _.chain(allPartsInRows)
    .filter((part) => Boolean(part?.id && duplicatePartUUIDs.includes(part.id)))
    .map('mpn')
    .compact()
    .uniq()
    .value();

  return duplicateMpns;
}
